(async () => {
  var e = await import(window.theme.modules.baseComponent);
  customElements.define(
    "product-recommendations",
    class extends e.default {
      render() {
        fetch(this.dataset.url)
          .then((e) => e.text())
          .then((e) => {
            const t = document.createElement("div");
            t.innerHTML = e;
            const n = t.querySelector("product-recommendations");
            n && n.innerHTML.trim().length && (this.innerHTML = n.innerHTML);
          })
          .catch((e) => {
            console.error(e);
          });
      }
    }
  );
})();
